"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var TechnicalInfo = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1["default"].createElement("div", { className: "TechnicalInfo" },
        react_1["default"].createElement("p", null,
            react_1["default"].createElement("u", null, t('technicalSkills'))),
        react_1["default"].createElement("p", null,
            react_1["default"].createElement("img", { src: "images/cpplogo.svg", height: 25 }),
            " ",
            t('cppSkills'),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/react_ts.png", height: 25 }),
            " ",
            t('reactTsSkills'),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/android.png", height: 25 }),
            " ",
            t('androidSkills'),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/javalogo.png", height: 25 }),
            " ",
            t('javaSkills'),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/python.png", height: 25 }),
            " ",
            t('pythonSkills'),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/angular.png", height: 25 }),
            " ",
            t('angularSkills'),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/csharp.png", height: 25 }),
            " ",
            t('csharpSkills'),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/asm.png", height: 25 }),
            " ",
            t('asmSkills'),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("img", { src: "images/linux.png", height: 25 }),
            " ",
            t('linuxSkills'),
            react_1["default"].createElement("br", null))));
};
exports["default"] = TechnicalInfo;
